
define('template!tasksCreatorView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="user-region"></div>\n<div class="name">' +
((__t = ( name )) == null ? '' : __t) +
'</div>';

}
return __p
};});

